import { PlanFeatureLimit } from 'cio/models/account';
import { isEmptyOrEmptyObject } from './objects';
import { isEmpty } from '@ember/utils';
import moment from 'moment-timezone';

export const getLimitValue = (feature: PlanFeatureLimit | Record<string, never>) => {
  // if the feature is an empty object it means there are no limits for this feature
  if (!isEmptyOrEmptyObject(feature)) {
    let featureLimits = feature as PlanFeatureLimit;
    return featureLimits.limit;
  }
  return false;
};

export const isExpired = (feature: PlanFeatureLimit | Record<string, never>) => {
  if (!isEmptyOrEmptyObject(feature) && !isEmpty(feature.start_at) && !isEmpty(feature.days)) {
    return moment(feature.start_at).add(feature.days, 'days').isBefore(moment());
  }

  return false;
};

export const getExpiresAt = (feature: PlanFeatureLimit | Record<string, never>) => {
  if (isEmptyOrEmptyObject(feature) || !feature.days) {
    return null;
  }
  return moment(feature.start_at).add(feature.days, 'days').unix();
};
